<template>
  <p class="account-msg">
    {{ t('policies.content') }}
    <a :href="policy" target='_blank'>{{ t('policies.policy') }}</a>
    , {{ t('policies.and') }}
    <a :href="terms" target='_blank'>{{ t('policies.terms') }}</a>{{ t('policies.comma') }}
    {{ t('policies.footer') }}
  </p>
</template>

<script setup>
  import { COUNTRY_TERMS, COUNTRY_POLICY } from "@u/helpers/siteData";
  import { useStore } from 'vuex';

  const { t } = useI18n();
  const store = useStore();
  
  const terms = computed(() => COUNTRY_TERMS.get(store.getters.language.current.cr));
  const policy = computed(() => COUNTRY_POLICY.get(store.getters.language.current.cr));

</script>

<style scoped lang="less">
  .account-msg {
    color: var(--weak-color); font-size: var(--font-small); line-height: 18px;
    a {color: var(--regular-color); font-weight: bold; cursor: pointer;}
  }
  @media screen and (max-width: 1280px) {
    .account-msg {line-height: 16px;}
  }
  @media screen and (max-width: 540px) {
    .account-msg {margin-bottom: var(--gap); text-align: center;}
  }
</style>
